// src/utils/constants.js
export const ADMIN_WALLET = '0x8BFC802e8DEcc49B63158b9ec4122E04a22D819c'.toLowerCase();

// Adult belt system (144 classes per promotion)
export const ADULT_BELT_SYSTEM = {
  white: { 
    name: 'White Belt', 
    color: '#ffffff', 
    gradient: 'linear-gradient(135deg, #ffffff, #f0f0f0)',
    classesRequired: 144,
    next: 'blue'
  },
  blue: { 
    name: 'Blue Belt', 
    color: '#007bff', 
    gradient: 'linear-gradient(135deg, #007bff, #0056b3)',
    classesRequired: 144,
    next: 'purple'
  },
  purple: { 
    name: 'Purple Belt', 
    color: '#800080', 
    gradient: 'linear-gradient(135deg, #800080, #4b0082)',
    classesRequired: 144,
    next: 'brown'
  },
  brown: { 
    name: 'Brown Belt', 
    color: '#8B4513', 
    gradient: 'linear-gradient(135deg, #8B4513, #654321)',
    classesRequired: 144,
    next: 'black'
  },
  black: { 
    name: 'Black Belt', 
    color: '#000000', 
    gradient: 'linear-gradient(135deg, #000000, #333333)',
    classesRequired: 0,
    next: null
  }
};

// Kids belt system (72 classes per promotion)
export const KIDS_BELT_SYSTEM = {
  white: { 
    name: 'White Belt', 
    color: '#ffffff', 
    gradient: 'linear-gradient(135deg, #ffffff, #f0f0f0)',
    classesRequired: 72,
    next: 'grey'
  },
  grey: { 
    name: 'Grey Belt', 
    color: '#6c757d', 
    gradient: 'linear-gradient(135deg, #6c757d, #495057)',
    classesRequired: 72,
    next: 'yellow'
  },
  yellow: { 
    name: 'Yellow Belt', 
    color: '#ffc107', 
    gradient: 'linear-gradient(135deg, #ffc107, #e0a800)',
    classesRequired: 72,
    next: 'orange'
  },
  orange: { 
    name: 'Orange Belt', 
    color: '#fd7e14', 
    gradient: 'linear-gradient(135deg, #fd7e14, #e8590c)',
    classesRequired: 72,
    next: 'green'
  },
  green: { 
    name: 'Green Belt', 
    color: '#28a745', 
    gradient: 'linear-gradient(135deg, #28a745, #1e7e34)',
    classesRequired: 0,
    next: null
  }
};

// Legacy system for backward compatibility
export const BELT_SYSTEM = ADULT_BELT_SYSTEM;

// Utility functions
export const getBeltSystem = (isAdult = true) => {
  return isAdult ? ADULT_BELT_SYSTEM : KIDS_BELT_SYSTEM;
};

export const getBeltInfo = (belt, isAdult = true) => {
  const system = getBeltSystem(isAdult);
  return system[belt] || system.white;
};